module.exports = __webpack_public_path__ + "fonts/AmplitudeTF-Italic_6a46a388.c1efa1b9.woff2";